<template>
  <div class="_additional-message-info">
    <h4 class="_section-title">
      ย้ายเข้าบัญชี Sellsuki
    </h4>
    <p class="_section-content">
      ลูกค้ามีบัญชี LINE OA อยู่แล้ว และต้องการเปลี่ยนจากการซื้อ แพ็กเกจตรงกับทาง LINE หรือซื้อกับเอเจนซี่อื่น มาซื้อแพ็กเกจกับ Sellsuki
    </p>
  </div>
</template>

<script>
export default {
  name: 'TransferLineOfficialAccountMoveInfo'
}
</script>

<style lang="scss" scoped>
._additional-message-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Prompt", sans-serif;
}

._section-title {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0%;
  color: #000000;
  margin: 0;
}

._section-content {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
}
</style>
